import { Heading, Paragraph } from '@finviz/website'
import React from 'react'

import { Theme } from '../../../../types/shared'
import { ChartEventBadgeType, ChartEventLabels } from '../../../constants/common'
import { CHART_EVENT_BADGE_SIZE } from '../../../models/constants'
import { ChartEventBadgeState, ISplit, getFormattedEventDate } from '../../../utils/chart-events-utils'
import { getChartEventBadgeElement } from '../badges/get-chart-event-badge-element'

export function ChartEventSplitPopoverContent({
  badgeType,
  rawData,
  theme,
}: {
  badgeType: ChartEventBadgeType
  rawData: ISplit
  theme: Theme
}) {
  return (
    <>
      <div className="mb-3 flex items-center space-x-1.5">
        {getChartEventBadgeElement({
          theme: theme,
          state: ChartEventBadgeState.default,
          width: CHART_EVENT_BADGE_SIZE,
          badgeType,
        })}{' '}
        <Heading
          level={4}
          className="my-0 text-base"
        >{`${ChartEventLabels[badgeType]}: ${rawData.factorFrom}/${rawData.factorTo}`}</Heading>
      </div>
      <table>
        <tbody>
          <tr>
            <td>
              <Paragraph size="small">{getFormattedEventDate(rawData.dateTimestamp)}</Paragraph>
            </td>
          </tr>
        </tbody>
      </table>
    </>
  )
}
